'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Online = void 0;
var config_1 = require("../config");
var Func = require("../func");
var $ = require("jquery");
var Online = /** @class */ (function () {
    function Online() {
        this.OVER_PC_WIDTH = config_1.default.OVER_PC_WIDTH;
        this.HEADER_HEIGHT = config_1.default.HEADER_HEIGHT;
        var self = this;
        $('#trigOnlineForm').on('click', function () {
            $('.bulletError').hide();
            self.getValues();
            if (self.validates()) {
                self.moveFormTop();
                return false;
            }
        });
    }
    Online.prototype.getValues = function () {
        this.choice = $('[name=choice]:checked').val();
        this.name = $('#name').val();
        this.email = $('#email').val();
        this.emailRe = $('#email_re').val();
        this.tel = $('#tel').val();
        this.postalCode = $('.paramOnlineInfoValue[data-name="postal_code"]').val();
        this.prefecture = $('.paramOnlineInfoValue[data-name="prefecture"] option:checked').val();
        this.address01 = $('.paramOnlineInfoValue[data-name="address01"]').val();
        this.accept = $('[name=accept]:checked').val();
    };
    Online.prototype.validates = function () {
        var errorFlag = false;
        this.errorName = "";
        if (Func.isNull(this.choice)) {
            errorFlag = true;
            $('.bulletErrorChoice').show();
            if (this.errorName == "") {
                this.errorName = 'paramFormChoice';
            }
        }
        if (Func.isNull(this.name)) {
            errorFlag = true;
            $('.bulletErrorName').show();
            if (this.errorName == "") {
                this.errorName = 'paramFormName';
            }
        }
        if (Func.isNull(this.email)) {
            errorFlag = true;
            $('.bulletErrorEmail').show();
            if (this.errorName == "") {
                this.errorName = 'paramErrorMail';
            }
        }
        else if (!Func.emailFormatCheck(this.email)) {
            errorFlag = true;
            $('.bulletErrorEmailFormat').show();
            if (this.errorName == "") {
                this.errorName = 'paramErrorMail';
            }
        }
        if (Func.isNull(this.emailRe)) {
            errorFlag = true;
            $('.bulletErrorEmailRe').show();
            if (this.errorName == "") {
                this.errorName = 'paramErrorMail';
            }
        }
        else if (this.email != this.emailRe) {
            errorFlag = true;
            $('.bulletErrorEmailRe').show();
            if (this.errorName == "") {
                this.errorName = 'paramErrorMail';
            }
        }
        if (Func.isNull(this.tel)) {
            errorFlag = true;
            $('.bulletErrorTel').show();
            if (this.errorName == "") {
                this.errorName = 'paramErrorTel';
            }
        }
        if (!Func.isNull(this.tel) && !Func.telFormatCheck(this.tel)) {
            errorFlag = true;
            $('.bulletErrorFormatTel').show();
            if (this.errorName == "") {
                this.errorName = 'paramErrorTel';
            }
        }
        if (Func.isNull(this.postalCode)) {
            errorFlag = true;
            $('.bulletOnlineInfoErrorMessage[data-name="postal_code"]').show();
            if (this.errorName == "") {
                this.errorName = 'paramErrorAddress';
            }
        }
        if (Func.isNull(this.prefecture)) {
            errorFlag = true;
            $('.bulletOnlineInfoErrorMessage[data-name="prefecture"]').show();
            if (this.errorName == "") {
                this.errorName = 'paramErrorAddress';
            }
        }
        if (Func.isNull(this.address01)) {
            errorFlag = true;
            $('.bulletOnlineInfoErrorMessage[data-name="address01"]').show();
            if (this.errorName == "") {
                this.errorName = 'paramErrorAddress';
            }
        }
        if (Func.isNull(this.accept)) {
            errorFlag = true;
            $('.bulletErrorAccept').show();
            if (this.errorName == "") {
                this.errorName = 'paramErrorAccept';
            }
        }
        return errorFlag;
    };
    Online.prototype.moveFormTop = function () {
        var windowWidth = $(window).outerWidth();
        var headerHeight = 0;
        if (this.OVER_PC_WIDTH <= windowWidth) {
            headerHeight = this.HEADER_HEIGHT;
        }
        var formPosition = $('.' + this.errorName).offset().top;
        $('html, body').animate({
            scrollTop: formPosition - headerHeight
        }, 'slow');
    };
    return Online;
}());
exports.Online = Online;
exports.default = Online;
